import React from 'react';
import { useQuery, Loading, Error } from 'react-admin';
import TableCell from '@material-ui/core/TableCell';


const DonorStatus = ({ssn,...props}) =>{
 
    let nssn =  (ssn)? ssn: ((props && props.record)? props.record.ssn :  null);

    const { data, loading, error } = useQuery({ 
        type: 'getOne',
        resource: 'donorstatus',
        payload:  {id: nssn}
    });

    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;
    console.log(data)
    return (
        
            <TableCell align="left">{(data && data.status === 'Q' ) ? <font color="green">Qualified Donor</font> : <font color="#C88141">Applicant Donor</font>}</TableCell>
    
        )
}

export default DonorStatus